import React from "react";
import PropTypes from "prop-types";
import LgrLink from "./LgrLink";
import MastermindLink from "./MastermindLink";
import HgncLink from "./HgncLink";
import AtlasLink from "./AtlasLink";
import KeggLink from "./KeggLink";
import TrapScoreLink from "../../../../../components/atoms/TrapScoreLink";

const AdditionalLinksOther = ({ selectedGene }) => {
  return (
    <div className="varsome-horiz-list-item">
      <div className="varsome-horiz-list-label">Other database links</div>
      <div className="varsome-horiz-list-value">
        <HgncLink geneSymbol={selectedGene.symbol} />
        <AtlasLink geneSymbol={selectedGene.symbol} />
        <LgrLink selectedGene={selectedGene} />
        <TrapScoreLink
          cssClasses="varsome-gene-link"
          trapQuery={selectedGene.symbol}
        />
        <MastermindLink geneSymbol={selectedGene.symbol} />
        <KeggLink geneSymbol={selectedGene.symbol} />
      </div>
    </div>
  );
};

AdditionalLinksOther.propTypes = {
  selectedGene: PropTypes.shape({ symbol: PropTypes.string }),
};

AdditionalLinksOther.defaultProps = {
  selectedGene: null,
};

export default AdditionalLinksOther;
